import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { c } from 'ttag';
import { UIFeature, GetDarkThemeFeature } from '@standardnotes/snjs';
import { TOGGLE_DARK_MODE_COMMAND } from '@standardnotes/ui-services';
import { classNames } from '@standardnotes/utils';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useKeyboardService } from '../KeyboardServiceProvider';
import Icon from '../Icon/Icon';
import Popover from '../Popover/Popover';
import QuickSettingsMenu from '../QuickSettingsMenu/QuickSettingsMenu';
import StyledTooltip from '../StyledTooltip/StyledTooltip';
import RoundIconButton from '../Button/RoundIconButton';
import mergeRegister from '../../Hooks/mergeRegister';
const QuickSettingsButton = ({ application, isMobileNavigation = false }) => {
    const buttonRef = useRef(null);
    const keyboardService = useKeyboardService();
    const [isOpen, setIsOpen] = useState(false);
    const toggleMenu = useCallback(() => setIsOpen((isOpen) => !isOpen), []);
    useEffect(() => {
        if (isMobileNavigation) {
            return;
        }
        const darkThemeFeature = new UIFeature(GetDarkThemeFeature());
        return mergeRegister(application.commands.addWithShortcut(TOGGLE_DARK_MODE_COMMAND, 'General', c('B2.NavSharedUI.Action').t `Toggle dark mode`, () => {
            void application.componentManager.toggleTheme(darkThemeFeature);
            return true;
        }), application.commands.add('open-quick-settings-menu', c('B2.NavSharedUI.Action').t `Open quick settings menu`, toggleMenu, 'themes'));
    }, [application, isMobileNavigation, keyboardService, toggleMenu]);
    return (_jsxs(_Fragment, { children: [_jsx(StyledTooltip, { label: c('B2.NavSharedUI.AriaLabel').t `Open quick settings menu`, children: isMobileNavigation ? (_jsx(RoundIconButton, { className: "ml-2.5 bg-default", onClick: toggleMenu, label: c('B2.NavSharedUI.AriaLabel').t `Go to quick settings menu`, icon: "themes" })) : (_jsx("button", { onClick: toggleMenu, className: "flex h-full w-8 cursor-pointer items-center justify-center", ref: buttonRef, children: _jsx("div", { className: "h-5", children: _jsx(Icon, { type: "themes", className: classNames(isOpen && 'text-info', 'rounded hover:text-info') }) }) })) }), _jsx(Popover, { title: c('B2.NavSharedUI.Title').t `Quick settings`, togglePopover: toggleMenu, anchorElement: buttonRef, open: isOpen, side: "top", align: "start", className: "md:py-2", children: _jsx(QuickSettingsMenu, { closeMenu: toggleMenu }) })] }));
};
export default QuickSettingsButton;
